import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TokenProvider } from './contexts/TokenContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProjectPage from './pages/ProjectPage';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import Settings from './pages/Settings';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicRoute } from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <TokenProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute redirectTo="/pricing"><Register /></PublicRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/project/:projectId" element={<ProtectedRoute><ProjectPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/billing/success" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </TokenProvider>
    </AuthProvider>
  );
}

export default App;
